import { detect } from "detect-browser";
import { debounce } from "lodash";

const characterList = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

export const toAbsoluteUrl = (pathname) => process.env.PUBLIC_URL + pathname;

export function getDeviceInfo() {
  const browser = detect();
  const deviceInfo = { deviceName: "", deviceId: "" };
  deviceInfo.deviceName = `${browser.os},${browser.name},v${browser.version}`;
  deviceInfo.deviceId = makeid(36);
  return deviceInfo;
}

function makeid(length) {
  let result = "";
  const charactersLength = characterList.length;
  for (let i = 0; i < length; i++) {
    result += characterList.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
// Please use custom hook brother, thanks
export function getCurrentUrl(location) {
  return location.pathname.split(/[?#]/)[0];
}
export function checkIsActive(location, url) {
  const current = getCurrentUrl(location);
  const currentSplit = current.split("/");

  if (!current || !url) {
    return false;
  }

  if (current === url) {
    return true;
  }

  if (url.split("/").every((urlPiece) => currentSplit.includes(urlPiece))) {
    return true;
  }

  return false;
}

// * this function for download file from server
export const downloadFile = async (url, filename) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error("Network response was not ok");

    const blob = await response.blob();
    const urlBlob = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = urlBlob;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(urlBlob);
  } catch (error) {
    console.error("There was an error downloading the file:", error);
  }
};

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const toastGenerator = ({ payrollConfirmAlert = false, status = "success", message = "" }) => {
  const isKh = localStorage.getItem("i18nextLng") === "kh";
  const toastTitle = {
    success: () => (isKh ? `ព័ត៌មាន` : `Information`),
    warning: () => (isKh ? `ព័ត៌មាន` : `Information`),
    error: () => (isKh ? `កំហុស` : `Something went wrong`),
    info: () => (isKh ? `ព័ត៌មាន` : `Information`),
  };
  const toastDescription = {
    success: () => (isKh ? `ទិន្ន័យបានរក្សាទុក` : `Data has been saved.`),
    warning: () => (message ? message : isKh ? `មិនអាចរក្សាទុកទិន្ន័យ` : `Unable to save data.`),
    error: () => (message ? message : isKh ? `សូមព្យយាមម្តងទៀត` : `Please try again.`),
    info: () => (message ? message : isKh ? `ព័ត៌មាន` : `Information`),
  };

  return {
    title: toastTitle[status](),
    description: toastDescription[status](),
    fontSize: "sm",
    status: status,
    variant: "subtle",
    duration: payrollConfirmAlert ? 80000 : 3000,
    position: "top",
    isClosable: true,
  };
};

export const isValidDate = (value) => {
  return value && value instanceof Date && !isNaN(value) ? value : null;
};

export const startOf = (type, date = new Date()) => {
  let result;
  switch (type) {
    case "day":
      result = new Date();
      break;
    case "week":
      let day = date.getDay();
      result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (day === 0 ? -6 : 1) - day);
      break;
    case "month":
      result = new Date(date.getFullYear(), date.getMonth(), 1);
      break;
    case "year":
      result = new Date(date.getFullYear(), 0, 1);
      break;
    default:
      result = date;
  }
  return result;
};

export const endOf = (type, date = new Date()) => {
  let result;
  switch (type) {
    case "day":
      result = new Date();
      break;
    case "week":
      let day = date.getDay();
      result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (day === 0 ? 0 : 7) - day);
      break;
    case "month":
      result = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      break;
    case "year":
      result = new Date(date.getFullYear(), 11, 31);
      break;
    default:
      result = date;
  }
  return result;
};

//short sentence ...
export function shortenSentence(sentence, maxLength = 30) {
  if (sentence?.length > maxLength) {
    return sentence.slice(0, maxLength) + "...";
  }
  return sentence;
}

// Available format: "integer", "decimal", "percentage", "currency"
export function formatNumber(input, formatType = "integer", options = {}) {
  if (input == null || input === "" || isNaN(input)) return "";
  const num = parseFloat(input);

  switch (formatType) {
    case "integer": {
      // "integer": "0,000"
      const parts = Math.round(num).toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join("");
    }
    case "decimal": {
      // "decimal": "0,000.00"
      const parsedNum = num.toFixed(2);
      const parts = parsedNum.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }
    case "percentage": {
      // "percentage": "0.00%"
      return `${(num * 100).toFixed(2)}%`;
    }
    case "currency": {
      // "currency": "$0,000.00"
      // or formatNumber(1234567.89, "currency", {
      //   symbol: "€", decimalPlaces: 2
      // })); -> Output: "€1,234,567.89"
      const { symbol = "$", decimalPlaces = 2 } = options;
      const parsedNum = num.toFixed(decimalPlaces);
      const parts = parsedNum.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return `${symbol}${parts.join(".")}`;
    }
    case "scientific": {
      // "scientific": "0.00e+00"
      return num.toExponential(2);
    }
    case "compact": {
      // "compact": 1234567.89 -> 1.23M
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        maximumFractionDigits: 2,
      }).format(num);
    }
    case "custom": {
      // "custom": formatNumber(1234567.89, "custom", {
      //   customFormatter: (num) => `Custom: ${num.toFixed(1)}`
      // }));   -> Output: "Custom: 1234567.9"
      const { customFormatter } = options;
      if (typeof customFormatter === "function") return customFormatter(num);
      return "";
    }
    default:
      return "";
  }
}
// Available format: "YYYY-MM-DD", "DD-MMM", "DD-MMM-YYYY","DD-MMM-YYYY HH:mm", "YYYY-MM-DD HH:mm", "DD/MM/YYYY HH:mm"
export function formatDate(dateInput, formatString = "YYYY-MM-DD") {
  if (!dateInput || (typeof dateInput !== "string" && !(dateInput instanceof Date))) return undefined;
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(date.getTime())) return "";

  const pad = (n) => String(n).padStart(2, "0");
  const day = pad(date.getDate());
  const monthShort = date.toLocaleString("en-US", { month: "short" });
  const monthNumeric = pad(date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  switch (formatString) {
    case "YYYY-MM-DD":
      return `${year}-${monthNumeric}-${day}`;
    case "DD-MMM":
      return `${day}-${monthShort}`;
    case "DD-MMM-YYYY":
      return `${day}-${monthShort}-${year}`;
    case "DD-MMM-YYYY HH:mm":
      return `${day}-${monthShort}-${year} ${hours}:${minutes}`;
    case "DD/MM/YYYY HH:mm":
      return `${day}/${monthNumeric}/${year} ${hours}:${minutes}`;
    case "YYYY-MM-DD HH:mm":
      return `${year}-${monthNumeric}-${day} ${hours}:${minutes}`;
    default:
      return "";
  }
}

// Combine array of objects
export function CombineArrayObject(data = [], def = []) {
  return [def, ...Object.values(data)];
}

export const backToParentList = debounce((history, parentUrl) => {
  history.push(`${parentUrl}/list`);
}, 1000);

export function formatAge(ageString) {
  if (typeof ageString !== "string" || ageString.trim() === "") {
    return "";
  }

  const years = ageString.match(/(\d+)\s*year/)?.[1] || 0;
  const months = ageString.match(/(\d+)\s*month/)?.[1] || 0;
  const days = ageString.match(/(\d+)\s*day/)?.[1] || 0;

  const yearValue = parseInt(years, 10);
  const monthValue = parseInt(months, 10);
  const dayValue = parseInt(days, 10);

  if (yearValue >= 1) {
    return `${yearValue} ${yearValue > 1 ? "years" : "year"}`;
  } else if (monthValue >= 1) {
    return `${monthValue} ${monthValue > 1 ? "months" : "month"}`;
  } else if (dayValue >= 1) {
    return `${dayValue} ${dayValue > 1 ? "days" : "day"}`;
  } else {
    return "0 day";
  }
}
